import apiSlice from './apiSlice';

export interface ProfitLossItem {
  id?: string;
  eventId?: string;
  marketId?: string;
  marketName?: string;
  marketType?: string;
  selectionId?: string;
  selectionName?: string;
  runnerName?: string;
  rate?: string;
  stake?: string;
  pl?: string; // Profit/Loss
  betOn?: 'BACK' | 'LAY';
  createdAt?: string;
  eventName?: string;
  matchId?: string;
  amount?: string | number;
  odds?: string | number;
  selection?: string;
  [key: string]: any;
}

export interface ProfitLossResponse {
  success?: boolean;
  message?: string;
  bets?: ProfitLossItem[];
  pagination?: Pagination;
}

export interface Pagination {
  totalItems: number;
  currentPage: number;
  limit: number;
  totalPage: number;
}

export interface CasinoProfitLossItem {
  id: number;
  gameId: number;
  gameName: string;
  roundId: string;
  txnId: string;
  userId: string;
  status: 'Won' | 'Lost' | 'Pending';
  totalBets: string;
  totalWins: string;
  totalLosses: string;
  completed: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface BetProfitLossResponse {
  success?: boolean;
  message?: string;
  bets?: ProfitLossItem[] | CasinoProfitLossItem[];
  pagination?: Pagination;
  filteredProfitLoss?: string | number;
  totalProfitLossAllSports?: string | number;
}

export interface ProfitLossQueryParams {
  page?: number;
  limit?: number;
  sport?: string;
  fromDate?: string;
  toDate?: string;
  search?: string;
}

export interface BetHistoryParams {
  page?: number;
  limit?: number;
  betTime: string;
  fromDate?: string;
  toDate?: string;
  eventId?: string;
  sport?: string;
  search?: string;
}

export interface ExportBetHistoryParams {
  page?: number;
  limit?: number;
  betTime: string;
  fromDate?: string;
  toDate?: string;
  status?: string;
  eventId?: string;
  sport?: string;
  search?: string;
  timezone?: string;
  fileName?: string;
  exportFormat?: 'Excel' | 'Pdf' | 'Csv';
}

export const betApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBetHistory: builder.query<ProfitLossResponse, BetHistoryParams>({
      query: (params) => ({
        url: '/bet/history',
        method: 'GET',
        params: { ...params, t: Date.now() },
      }),
      providesTags: ['BetPlace'],
    }),

    getProfitLoss: builder.query<BetProfitLossResponse, ProfitLossQueryParams>({
      query: (params) => ({
        url: '/bet/profit-loss',
        method: 'GET',
        params: { ...params, t: Date.now() },
      }),
      providesTags: ['BetPlace'],
    }),

    exportBetHistory: builder.query<Blob, ExportBetHistoryParams>({
      query: (params) => {
        const p = params || {};
        const queryParams: Record<string, string | number> = {};

        if (p.page !== undefined) queryParams.page = p.page;
        if (p.limit !== undefined) queryParams.limit = p.limit;
        if (p.betTime) queryParams.betTime = p.betTime;
        if (p.fromDate) queryParams.fromDate = p.fromDate;
        if (p.toDate) queryParams.toDate = p.toDate;
        if (p.status) queryParams.status = p.status;
        if (p.eventId) queryParams.eventId = p.eventId;
        if (p.sport) queryParams.sport = p.sport;
        if (p.search) queryParams.search = p.search;
        if (p.timezone) queryParams.timezone = p.timezone;
        if (p.fileName) queryParams.fileName = p.fileName;
        if (p.exportFormat) queryParams.exportFormat = p.exportFormat;

        return {
          url: '/bet/export-history',
          method: 'POST',
          params: { t: Date.now(), ...queryParams },
          responseHandler: (response: Response) => response.blob(),
          cache: 'no-cache',
        };
      },
    }),
  }),
});

export const { useGetBetHistoryQuery, useGetProfitLossQuery, useLazyExportBetHistoryQuery } =
  betApi;
